import moment from 'moment';

export default function getFormatedDate(date,format) {
    if(date) return moment(date).format(format ? format : 'll');
}